/* Read more / Read less collapse for long rich text (OL-3526, epic OL-3521 Enhanced PDP v2) */
if (!customElements.get('component-read-more')) {
  customElements.define(
    'component-read-more',
    class ReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-read-more-content]');
        this.toggle = this.querySelector('[data-read-more-toggle]');
        if (!this.content || !this.toggle) return;
        this.collapsedHeight = parseInt(this.dataset.collapsedHeight, 10) || 96;
        if (this.content.scrollHeight <= this.collapsedHeight) {
          this.classList.remove('read-more--collapsed');
          this.classList.add('read-more--static');
          this.content.style.maxHeight = '';
          return;
        }
        this.classList.add('read-more--collapsed');
        this.content.style.maxHeight = `${this.collapsedHeight}px`;
        this.toggle.addEventListener('click', () => this.toggleContent());
      }

      toggleContent() {
        const expand = this.classList.contains('read-more--collapsed');
        this.classList.toggle('read-more--collapsed', !expand);
        this.content.style.maxHeight = expand ? `${this.content.scrollHeight}px` : `${this.collapsedHeight}px`;
        this.toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
        this.querySelector('[data-label-more]').hidden = expand;
        this.querySelector('[data-label-less]').hidden = !expand;
      }
    }
  );
}
